var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const FullScreen = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-full_screen ${className}`} {...other}>
      <g>
        <path d="M10 13.5h3.5V10a.5.5 0 01.5-.5h.5a.5.5 0 01.5.5v4a1 1 0 01-1 1h-4a.5.5 0 01-.5-.5V14a.5.5 0 01.5-.5zM1 6V2a1 1 0 011-1h4a.5.5 0 01.5.5V2a.5.5 0 01-.5.5H2.5V6a.5.5 0 01-.5.5h-.5A.5.5 0 011 6zm12.996-5a1 1 0 01.993.883l.007.121L15 6a.5.5 0 01-.5.5h-.48a.5.5 0 01-.5-.496L13.5 3.52 9.745 7.334a.5.5 0 01-.707.006l-.39-.384a.5.5 0 01-.005-.708L12.332 2.5H10a.5.5 0 01-.5-.5v-.5A.5.5 0 0110 1h3.996zM2 14.995a1 1 0 01-.993-.883L1 13.99l.022-3.994a.5.5 0 01.5-.497H2a.5.5 0 01.5.5l-.002 2.475 3.768-3.821a.501.501 0 01.708-.005l.39.384a.5.5 0 01.005.707l-3.704 3.756L6 13.5a.5.5 0 01.499.5v.5a.5.5 0 01-.5.5l-4-.004z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default FullScreen;
